import moment from 'moment';

/**
 * Deep-sanitize an object for GraphQL mutation variables.
 * Strips DOM nodes, functions, circular refs, and serializes Moment objects to ISO strings.
 */
const sanitizePayload = (obj, path = 'root') => {
  const seen = new WeakSet();

  const walk = (value, currentPath) => {
    if (moment.isMoment && moment.isMoment(value)) {
      return value.toISOString();
    }
    if (value instanceof HTMLElement || value instanceof Node) {
      // eslint-disable-next-line no-console
      console.error(`[sanitizePayload] Stripped DOM node at ${currentPath}:`, value);
      return undefined;
    }
    if (typeof value === 'function') {
      return undefined;
    }
    if (value === null || typeof value !== 'object') {
      return value;
    }
    if (seen.has(value)) {
      // eslint-disable-next-line no-console
      console.error(`[sanitizePayload] Stripped circular reference at ${currentPath}`);
      return undefined;
    }

    seen.add(value);

    if (Array.isArray(value)) {
      return value
        .map((item, i) => walk(item, `${currentPath}[${i}]`))
        .filter((item) => item !== undefined);
    }

    const cleaned = {};
    Object.keys(value).forEach((key) => {
      const result = walk(value[key], `${currentPath}.${key}`);
      if (result !== undefined) {
        cleaned[key] = result;
      }
    });
    return cleaned;
  };

  return walk(obj, path);
};

export default sanitizePayload;
